import { Canvas, useFrame } from '@react-three/fiber'
import { Text, MeshReflectorMaterial, BakeShadows, Icosahedron, RoundedBox, Float } from '@react-three/drei'
import { EffectComposer, Bloom, DepthOfField } from '@react-three/postprocessing'
import { easing } from 'maath'
import { Instances, Computers } from './components/Computers'
import { useState, useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const Content = () => {
  // navigate
  const navigate = useNavigate();
  const handleOnClick = useCallback(() => navigate('/', {replace: true}), [navigate]);

  const [hovered, hover] = useState(false)
  const [hovered1, hover1] = useState(false)
  const [hovered2, hover2] = useState(false)

  useEffect(() => {
    document.body.style.cursor = hovered ? 'pointer' : 'auto'
  }, [hovered])
  return(
    <>
    <mesh
    onPointerDown={() => handleOnClick()}
    onPointerOver={() => hover(true)}
    onPointerOut={() => hover(false)}
    >
    <Text 
    onPointerOver={(event) => hover(true)}
    onPointerOut={(event) => hover(false)}
    font="/Inter-Medium.woff" 
    position={[0, 0.4, 0.5]}  
    fontSize={0.7} 
    letterSpacing={-0.1} 
    
    color={hovered ? '#35c19f' : '#0096c7'}>
        Projects
    </Text>
    </mesh>
    <Text 
    onPointerOver={() => hover1(true)}
    onPointerOut={() => hover1(false)}
    font="/Inter-Medium.woff" 
    position={[0, 3, -1.8]}  
    fontSize={0.3} 
    letterSpacing={-0.1} 
    color={hovered1 ? '#35c19f' : '#0096c7'}>
        {`About me`}
    </Text>
    <Text 
    onPointerOver={() => hover2(true)}
    onPointerOut={() => hover2(false)}
    font="/Inter-Medium.woff" 
    position={[-1.5, 3.1, -1.5]}  
    fontSize={0.3} 
    rotation={[0, 0.7, 0]}
    letterSpacing={-0.1} 
    color={hovered2 ? '#35c19f' : '#0096c7'}>
        {`<React JS />\n<Next  JS />`}
    </Text>
    <Text 
    onPointerOver={() => hover2(true)}
    onPointerOut={() => hover2(false)}
    font="/Inter-Medium.woff" 
    position={[1.5, 3.1, -1.5]}  
    fontSize={0.3} 
    rotation={[0, -0.7, 0]}
    letterSpacing={-0.1} 
    color={hovered2 ? '#35c19f' : '#0096c7'}>
        {`HTML\nCSS\nJS`}
    </Text>
    </>
  )
}



export default function App() {
  return (
    <Canvas shadows dpr={[1, 1.5]} camera={{ position: [-1.5, 1, 5.5], fov: 45, near: 1, far: 20 }} eventSource={document.getElementById('root')} eventPrefix="client">
      {/* Lights */}
      <color attach="background" args={['black']} />
      <hemisphereLight intensity={0.15} groundColor="black" />
      <spotLight position={[10, 20, 10]} angle={0.12} penumbra={1} intensity={1} castShadow shadow-mapSize={1024} />
      {/* Main scene */}
      <group position={[-0, -1, 0]}>
        {/* Auto-instanced sketchfab model */}
        <Instances>
          <Computers scale={0.5} />
        </Instances>
        {/* Plane reflections + distance blur */}
        <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
          <planeGeometry args={[50, 50]} />
          <MeshReflectorMaterial
            blur={[300, 30]}
            resolution={2048}
            mixBlur={1}
            mixStrength={80}
            roughness={1}
            depthScale={1.2}
            minDepthThreshold={0.4}
            maxDepthThreshold={1.4}
            color="#202020"
            metalness={0.8}
          />
        </mesh>
        <Content />
        <pointLight distance={1.5} intensity={3} position={[-0.15, 0.7, 0]} color="orange" />
        <pointLight distance={5} intensity={1} position={[-0.15, 2, 0]} color="lightblue" />
      </group>
      {/* Postprocessing */}
      <EffectComposer disableNormalPass>
        <Bloom luminanceThreshold={0} mipmapBlur luminanceSmoothing={0.0} intensity={5} />
      </EffectComposer>
      {/* Camera movements */}
      <CameraRig />
      {/* Small helper that freezes the shadows for better performance */}
      <BakeShadows />
    </Canvas>
  )
}


function CameraRig() {
  useFrame((state, delta) => {
    easing.damp3(state.camera.position, [-1 + (-state.pointer.x * state.viewport.width) / 5, (state.pointer.y) / 2, 5.5], 0.5, delta)
    state.camera.lookAt(0, 0, 0)
  })
}
